export const TEST_ID = 'lastSynced';
